// ==================================== COMPONENTS =========================================
// THIRD PARTY/ CORE COMPONENTS
import React from 'react';
import propTypes from 'prop-types';

// USER COMPONENTS
import { Button } from '../../../components/buttons/buttons';
import { Modal } from '../../../components/modals/antd-modals';
import { BasicFormWrapper } from '../../styled';

const DeleteBlog = ({ visible, onCancel, blog, handleDelete }) => {
  // To handle the delete
  const handleSubmit = () => {
    handleDelete(blog._id)
    onCancel();
  }

  return (
    <Modal
      type={'primary'}
      title="Delete Blog"
      visible={visible}
      footer={[
        <div key="1" className="blog-modal-footer">
          <Button size="default" style={{ backgroundColor: '#155BDC', color: '#fff' }} key="submit" onClick={handleSubmit}>
            Delete Blog
          </Button>
          <Button size="default" type="white" key="back" outlined onClick={onCancel}>
            Cancel
          </Button>
        </div>,
      ]}
      onCancel={onCancel}
    >
      <div className="blog-modal">
        <BasicFormWrapper>
          <p>Delete blog "{blog.details[0]?.title}"</p>
        </BasicFormWrapper>
      </div>
    </Modal>
  );
};

DeleteBlog.propTypes = {
  visible: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
};

export default DeleteBlog;